import { render, staticRenderFns } from "./EditCase.vue?vue&type=template&id=81c518e2"
import script from "./EditCase.vue?vue&type=script&lang=js"
export * from "./EditCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports